import { __assign } from "tslib";
import { testDataCreator } from '@wix/answers-lib';
import { createOverviewStats } from '../../callcenter';
var timeZone = 'UTC';
export var createTeamPerformanceAnalyticsFilterDto = testDataCreator({
    startDate: '1988-31-10',
    endDate: '1988-31-10',
    timeZone: timeZone
});
export var createGetTeamPerformanceOverviewDto = testDataCreator(function () { return (__assign({ metrics: [] }, createTeamPerformanceAnalyticsFilterDto())); });
export var createTeamPerformanceOverviewStatsComparison = testDataCreator(function () { return ({
    value: createOverviewStats(),
    compared: createOverviewStats()
}); });
//# sourceMappingURL=builders.js.map